import React from 'react';
import styled from 'styled-components';

const CountryLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: ${(props) => props.theme.colors.dark};
  font-size: 12px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .country-label-title {
    text-transform: ${(props) => (props.country ? 'capitalize' : 'uppercase')};
    font-size: ${(props) => (props.city ? '10px' : '12px')};
    opacity: ${(props) => (props.city ? 0.5 : 1)};

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: none;
    }
  }

  .country-label-flag {
    font-size: 14px;
    border-radius: 4px;
    margin-right: 5px;
  }

  .country-label-city {
  }

  ${(props) => props.customStyles}
`;

const CountryLabel = ({
  style,
  styleFlag,
  country,
  city,
  name,
  styleLabel,
  customStyles,
  onlyFlag
}) => {
  let image;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    image = require(
      '../../assets/images/flags/' + name.toUpperCase()
    ).default();
  } catch {
    // pass
  }

  return (
    <CountryLabelContainer
      country={country}
      city={city}
      customStyles={customStyles}
      style={style}
    >
      <span style={styleFlag} className="country-label-flag">
        {name && image}
      </span>
      {!onlyFlag &&
        (city ? (
          <div>
            <p className="country-label-city">{city}</p>
            <p className="country-label-title" style={styleLabel}>
              &nbsp;({name})
            </p>
          </div>
        ) : (
          <p className="country-label-title" style={styleLabel}>
            {country || name}
          </p>
        ))}
    </CountryLabelContainer>
  );
};

export default CountryLabel;
